import { render, staticRenderFns } from "./ParameterSideBar.vue?vue&type=template&id=608efe93&scoped=true&"
import script from "./ParameterSideBar.vue?vue&type=script&lang=js&"
export * from "./ParameterSideBar.vue?vue&type=script&lang=js&"
import style0 from "./ParameterSideBar.vue?vue&type=style&index=0&id=608efe93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608efe93",
  null
  
)

export default component.exports